import React from 'react';
import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.7;
  }
`;

const bounce = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
`;

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: var(--space-16);
  padding: var(--space-8);
  gap: var(--space-2);
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: var(--radius-full);
  background: linear-gradient(135deg, var(--primary-600), var(--primary-700));
  animation: ${bounce} 1.4s ease-in-out infinite both;
  box-shadow: 0 2px 4px rgba(90, 99, 230, 0.3);

  &:nth-child(1) { animation-delay: -0.32s; }
  &:nth-child(2) { animation-delay: -0.16s; }
  &:nth-child(3) { animation-delay: 0s; }
`;

function LoadingSpinner() {
  return (
    <SpinnerContainer>
      <Dot />
      <Dot />
      <Dot />
    </SpinnerContainer>
  );
}

export default LoadingSpinner;